import { Dayjs } from '@util/dayjs'
import { MixedSchema, mixed } from 'yup'

// Side effect: add methods to Yup.mixed()
import '@data/schemas/util/dayjs'

/**
 * Custom schema for Dayjs objects
 */
function dayjsSchema(): MixedSchema<Dayjs | null> {
    return mixed<Dayjs>().dayjs().nullable().required()
}

export default dayjsSchema
